module.exports = __webpack_public_path__ + "img/credit-card.65ecf7ee.png";